<h1 class="title">{{'SITE-PAGE.TITLE' | translate}}</h1>
<div class="add-btn">
    <button routerLink="/site-details/new" mat-fab aria-label="">
        <mat-icon>add</mat-icon>
    </button>
</div>

<mat-card>
    <mat-card-content>
        <vzn-data-table #table [restService]="siteService" [pageSize]="25" [columns]="columns" [query]="query"
            [mapper]="siteMapper" (rowDblClick)="onDoubleClick($event)">
        </vzn-data-table>
        <ng-template #previewButtonTmpl let-row="row" let-height="column.height" ngx-datatable-cell-template>
            <a target="_blank" [href]="row.previewLink">
                <button mat-raised-button>{{'SITE-PAGE.SHOW' | translate}}</button>
            </a>
        </ng-template>
    </mat-card-content>
</mat-card>